export default __webpack_public_path__ + "static/media/3.f8303c83.jpg";